import appStore from "store";
import api from "./api";
import { PAGINATION } from "./constants";

const store = {
  namespaced: true,
  state: {
    tradePairList: [],
    pagination: PAGINATION,
    totalCount: 0,
    coinList: [],
    tradeArea: [],
    markCoinOption:[],
    offerCoinOption:[],
    updateDialog: false,
  },
  getters: {
    tradePairList: (state) => state.tradePairList,
    coinList: (state) =>
      state.coinList.map((coin) => {
        return {
          label: coin,
          value: coin,
        };
      }),
    tradeArea: (state) =>
      state.tradeArea.map((area) => {
        return {
          label: area,
          value: area,
        };
      }),
  },
  mutations: {
    setTradePairList(state, payload) {
      state.tradePairList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setMarkCoin(state, payload) {
      state.markCoinOption =payload;
    },
    setOfferCoin(state, payload) {
      state.offerCoinOption =payload;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    },
    setTradeArea(state, payload) {
      state.tradeArea = payload;
    },
    setUpdaterDialog(state, payload) {
      state.updateDialog = payload;
    },
  },
  actions: {
    delKlineData({commit},symbol){
      return api.delKlineData(symbol).then(res=>{
        return res
      })
    },
    getKlineData({commit},payload){
      return api.getKlineData(payload).then(res=>{
        return res
      })
    },
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit("setCoinList", data);
      });
    },
    getAllSymbol({ commit }, { page, size, symbol, buyCoin ,state}) {
      api.getAllSymbol({ page, size, symbol, buyCoin ,state}).then((res) => {
        commit("setPagination", { page, size });
        commit("setTradePairList", res.data);
        // return res
      });
    },
    //删除交易对
  async  delSymbol({ commit },id) {
    const res=await  api.delSymbol(id)
    return res
     
    },
    //开启或关闭热门功能
    async hotSwitch({ commit }, { id, hot }) {
      const res = await api.hotSwitch({ id, hot });
      return res;
    },
    // symbol开启隐藏
    async symbolSwitch({ commit }, { id, type }) {
      const res = await api.symbolSwitch({ id, type });
      return res;
    },
    // tradeSwitch交易开关
    async tradeSwitch({ commit }, { id, type }) {
      const res = await api.tradeSwitch({ id, type });
      return res;
    },
    //更新后的创建交易对
   async createTradeSymbol({ commit }, data) {
   const res=await   api.createTradeSymbol(data)
        return res;
    },
    //更新后的更新交易对信息
    async updateSymbol({ commit },  symbol ) {
      const res = await api.updateSymbol( symbol );
      return res
    },
    list({ commit }, { pair, area, page, size }) {
      api.getTradePairList({ pair, area, page, size }).then(({ data }) => {
        commit("setPagination", { page, size });
        commit("setTradePairList", data);
      });
    },
    // eslint-disable-next-line
    updateTradeStatus({ commit }, data) {
      return new Promise((resolve) => {
        api.updateTradeStatus(data).then((res) => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    create({ commit }, tradePair) {
      return new Promise((resolve) => {
        api.createTradePair(tradePair).then((res) => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    remove({ commit }, pair) {
      return new Promise((resolve) => {
        api.removeTradePair(pair).then((res) => {
          resolve(res);
        });
      });
    },
    // eslint-disable-next-line
    updateDefaultPrecision({ commit }, data) {
      return api.updateDefaultPrecision(data);
    },
    updateAmountPrecision({ commit }, data) {
      return api.updateAmountPrecision(data);
    },
    // eslint-disable-next-line
    transaction({ commit }, data) {
      return api.transaction(data);
    },
    getTradeArea({ commit }) {
      return api.getTradeArea().then(({ data }) => {
        commit("setTradeArea", data);
      });
    },
    updateSort(context, data) {
      return api.updateSort(data);
    },
    updateTradePair(context, data) {
      return api.updateTradePair(data);
    },
  },
};

appStore.registerModule("tradePairSetting", store);
